import Decimal from 'decimal.js';
import { SendungsstatusModel } from '../models/SendungsstatusModel';

/*
 * Summiert mehrere Dezimalzahlen.
 * Durch Verwendung dieser Funktion sollen Fehler
 * in der Darstellung von Floats vermieden werden:
 * 0.2 + 0.4 = 0.6000000000000001 ist häufig problematisch
 *
 * @param numbers Liste von Nummern die summiert werden sollen
 * @returns die Summe der übergebenen Zahlen
 */
export const addDecimalNumbers = (numbers: number[]): number => {
  return numbers.reduce((accumulator: number, number: number): number => {
    return new Decimal(accumulator).add(new Decimal(number)).toNumber();
  });
};

/**
 * Konvertiert ein Iso-Datum in das deutsche Format OHNE Beachtung der UTC Zeit.
 * @param isodate 2021-10-15T00:00:00Z
 * @param locale Datumslokalisierung, default "de-DE" ~ Deutsch
 * @returns date "15.10.2021"-Format (locale abhängig)
 */
export const utcIsoDateToLocaleDate = (
  isodate: string | number | Date,
  locale = 'de-DE'
): string => {
  let date: Date | string = '';
  if (isodate) {
    date = new Date(isodate);
    date = date.toLocaleDateString(locale, {
      timeZone: 'UTC',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    });
  }
  return date;
};

/**
 * Konvertiert ein Iso-Datum in das deutsche Format mit Beachtung der UTC Zeit.
 * @param isodate 2021-10-15T00:00:00Z
 * @param locale Datumslokalisierung, default "de-DE" ~ Deutsch
 * @returns date "Mo 15.10.2021, 12:51"-Format (locale abhängig)
 */
export const utcIsoDateToLocaleDateAndDay = (
  isodate: string | number | Date,
  locale = 'de-DE'
): string => {
  let date: Date | string = '';
  if (isodate) {
    date = new Date(isodate);
    date = date.toLocaleDateString(locale, {
      timeZone: 'UTC',
      weekday: 'short',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    });
  }
  return date;
};

export const byDatumAscending = (
  a: SendungsstatusModel,
  b: SendungsstatusModel
) => {
  if (a?.date && b?.date) {
    return a.date < b.date ? -1 : 1;
  }

  return a.date ? -1 : 1;
};

export const byAnzeigefolge = (
  a: SendungsstatusModel,
  b: SendungsstatusModel
) => {
  if (a.anzeigefolge && b.anzeigefolge) {
    return a.anzeigefolge < b.anzeigefolge ? -1 : 1;
  }
  return 0;
};

export const nameof = <T>(name: keyof T) => name.toString();
